export enum EExceptionState {
    Review,
    Approved,
    Rejected
}